import React from 'react';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { VariantThumbnail } from './VariantThumbnail/VariantThumbnail';
import { styles } from './ProductCardVariants.css';
import { ProductCardVariant } from '../ProductCard';
import { ProductVariant } from '../types';
import { AlgoliaHitTransformer } from '../../Algolia/transformers/AlgoliaHitTransformer';
import { ProductImageFallback } from '../../ProductImageFallback/ProductImageFallback';

export type ProductCardVariantsProps = {
  variants: Array<ProductVariant>;
  variantType?: ProductCardVariant;
  setSelectedVariant: (variant: ProductVariant) => void;
  selectedVariant?: ProductVariant;
};

export const ProductCardVariants = ({
  variants,
  variantType = 'default',
  setSelectedVariant,
  selectedVariant,
}: ProductCardVariantsProps) => {
  return (
    <div className={styles.variantCarousel({ variantType })}>
      <Carousel
        slidesPerView={'auto'}
        fullHeightItems={false}
        slidesOffsetAfter={1}
        slidesOffsetBefore={1}
        spaceBetween={variantType === 'small' ? 4 : 10}
        showArrows
        arrowPosition="middle"
        showProgressBar={false}
        showPagination={false}
        slideArrowClassName={styles.variantSlide}
      >
        {variants.map(productVariant => {
          return (
            <VariantThumbnail
              key={`variant-${productVariant.variantId}`}
              onClick={() => setSelectedVariant(productVariant)}
              isSelected={selectedVariant?.variantId === productVariant.variantId}
            >
              {productVariant.specRender === 'Swatches' ? (
                productVariant.productImage ? (
                  <img
                    title={productVariant.variantValue}
                    alt={productVariant.variantValue}
                    className={styles.thumbnailImage}
                    {...AlgoliaHitTransformer.toImageProps(
                      { product_image: productVariant.productImage, title: productVariant.variantValue },
                      { sizePx: 80 }
                    )}
                  />
                ) : (
                  <ProductImageFallback className={styles.thumbnailImage} shouldHideBorder />
                )
              ) : (
                productVariant.variantValue
              )}
            </VariantThumbnail>
          );
        })}
      </Carousel>
    </div>
  );
};
